'use client'

import { Suspense } from 'react'
import { AuthForm } from '@/components/auth/auth-form'
import { useAuthPageEffects } from '@/hooks/useAuthPageEffects'
import { Skeleton } from '@/components/ui/skeleton'

function LoginPageContent() {
  useAuthPageEffects({ route: '/login' })

  return (
    <AuthForm 
      title="Log in to atrium"
      subtitle="Choose your preferred authentication method"
      showTerms={false}
      redirectPath="/campaigns"
      isSignup={false}
      switchAuthLink={{
        text: "Don't have an account?",
        linkText: "Sign up",
        href: "/signup"
      }}
    />
  )
}

function LoginFallback() {
  return (
    <div className="mx-auto flex w-full max-w-md flex-col items-center gap-4 px-4 py-6 sm:px-6">
      <Skeleton className="h-8 w-48 rounded-md" />
      <Skeleton className="h-4 w-full max-w-sm rounded-md" />
      <Skeleton className="h-11 w-full max-w-sm rounded-md" />
      <Skeleton className="h-11 w-full max-w-sm rounded-md" />
    </div>
  )
}

export default function LoginPage() {
  return (
    <Suspense fallback={<LoginFallback />}>
      <LoginPageContent />
    </Suspense>
  )
}

